import * as types from './types'

export default {
  [types.INIT_VEHICLE](state) {
    state.vehicle = JSON.parse(JSON.stringify(state.defaultVehicle))
  },
  [types.UPDATE_VEHICLE](state, data) {
    if (state.vehicle !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.vehicle.firm = parseInt(data.value)
          break
        case 'contact':
          state.vehicle.contact = parseInt(data.value)
          break
        case 'year':
          state.vehicle.year = parseInt(data.value)
          break
        case 'make':
          state.vehicle.make = parseInt(data.value)
          break
        case 'model':
          state.vehicle.model = data.value
          break
        case 'vin':
          state.vehicle.vin = data.value
          break
      }
    }
  },
  [types.SET_VEHICLES](state, data) {
    state.vehicles = data
  },
  [types.SET_VEHICLE](state, data) {
    state.vehicle = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/mutations.js